<template>
    <div class="news">
        <!-- 图片 -->
        <div class="banner">
            <img src="../assets/img/news/1.png" alt="">
            <h2>新闻资讯</h2>
        </div>
        <!-- Our News 关注纸搬客最新资讯 -->
        <div class="content">
            <div class="content-header">
                <h2>Our News</h2>
                <h3>关注纸搬客最新资讯</h3>
            </div>
            <div v-for="(i,index) in news_arr" :key="index">
                <div class="details line">
                    <div class="details-left">
                        <img :src="i.img" alt="">
                    </div>
                    <div class="details-right">
                        <h3>{{i.h3}}</h3>
                        <p>{{i.p}}</p>
                        <div class="inline">
                            <router-link :to="i.path" target="_blank">
                                <div class="more">{{i.more}}</div>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="details line">
                <div class="details-left">
                    <img src="../assets/img/news/2.png" alt="">
                </div>
                <div class="details-right">
                    <h3>纸搬客——互联网+时代的智能废纸回收先行者</h3>
                    <p>纸搬客诞生于2018年，时值国家重拳出击整治环保、垃圾分类政策相继出台的风口浪尖。据李总介绍，纸搬客的创始初衷其实很简单，就是便于日常生活中产生的大量废旧纸类垃圾进行精准分类和回收再利用...</p>
                    <div class="inline">
                        <router-link to="/newOne" target="_blank">
                            <div class="more">查看更多></div>
                        </router-link>
                    </div>
                </div>
            </div>
            <div class="details line">
                <div class="details-left">
                    <img src="../assets/img/news/3.png" alt="">
                </div>
                <div class="details-right">
                    <h3>纸搬客南华里社区环保专题采访</h3>
                    <p>为响应国家垃圾分类的环保号召、助力垃圾分类，纸搬客通过与社区物业、居委会单位的合作，将自主研发的纸搬客智能废纸回收机入驻社区，协助物业、居委会建立社区内的垃圾分类回收体系，为用户挖掘“垃圾”价值，这一方式受到了物业、居委会以及用户的一致好评。</p>
                    <div class="inline">
                        <router-link to="/newTwo" target="_blank">
                            <div class="more">查看更多></div>
                        </router-link>
                    </div>
                </div>
            </div>
            <div class="details line">
                <div class="details-left">
                    <img src="../assets/img/news/4.png" alt="">
                </div>
                <div class="details-right">
                    <h3>纸搬客创始人兼CEO李嘉轩谈受访专题</h3>
                    <p>世界地球日当天，“首度财经频道”晚间新闻栏目，“世界地球日-环保专题”邀请纸搬客创始人兼CEO李嘉轩李总，为财经频道观众分享在互联网+模式下，纸搬客作为一家互联网环保公司做出的创新与发展。</p>
                    <div class="inline">
                        <router-link to="/newThree" target="_blank">
                            <div class="more">查看更多></div>
                        </router-link>
                    </div>
                </div>
            </div> -->
        </div>
        <!-- footer -->
        <footer_s></footer_s>
    </div>
</template>
<script>
    import footer_s from './common/footer'
    import $ from 'jquery'
    export default {
        components: {
            footer_s,
        },
        data() {
            return {
                news_arr: [
                    {
                        img: require('../assets/img/news/7.png'),
                        h3: '垃圾分类，风雨无阻',
                        p: '七月流火、酷暑难耐，久违的降雨给酷热中的首都人民带来了一丝清爽。垃圾分类是今年北京市政府工作的一项重要内容，全市各小区都在积极开展相关工作。在我们所走访的众多小区中，居民无论是从环保意识还是实际行动上都给予了垃圾分类工作巨大的支持，在这里我们为首都人民点赞！',
                        small: '收费0.5元一条',
                        more: '查看更多>',
                        path: '/newSeven'
                    },
                    {
                        img: require('../assets/img/news/6.png'),
                        h3: '纸搬客入驻彩虹园等社区',
                        p: '经过两个多月的努力，纸搬客在京打造纸类垃圾回收的区域布局又有新突破。近日，纸搬客成功入驻了彩虹园、密西花园和季庄小区，随后还将陆续进驻梧桐苑、果园等多个社区。至此，纸搬客在密云与十几个小区建立了合作关系，以密云为核心的区域布局初步形成。酷暑难耐，纸搬客带着满满的环保之心为密云的垃圾分类贡献一份微薄之力！',
                        small: '收费0.5元一条',
                        more: '查看更多>',
                        path: '/newSix'
                    },
                    {
                        img: require('../assets/img/news/5.png'),
                        h3: '新一代纸搬客智能废纸回收机器即将面世',
                        p: '2020诸事坎坷，但是纸搬客全体成员齐心协力，参考过去广大用户提出的宝贵建议，结合纸搬客自身的一些进步和经验，终于推出了新一代智能废纸回收机器，并于近期和广大用户见面。',
                        small: '收费0.5元一条',
                        more: '查看更多>',
                        path: '/newFive'
                    },
                    {
                        img: require('../assets/img/news/4.png'),
                        h3: '新一代纸搬客智能废纸回收机器即将面世',
                        p: '2020诸事坎坷，但是纸搬客全体成员齐心协力，参考过去广大用户提出的宝贵建议，结合纸搬客自身的一些进步和经验，终于推出了新一代智能废纸回收机器，并于近期和广大用户见面。',
                        small: '收费0.5元一条',
                        more: '查看更多>',
                        path: '/newFour'
                    },
                    {
                        img: require('../assets/img/news/4.png'),
                        h3: '纸搬客创始人兼CEO李嘉轩受访专题',
                        p: '世界地球日当天，“首度财经频道”晚间新闻栏目，“世界地球日-环保专题”邀请纸搬客创始人兼CEO李嘉轩，为财经频道观众分享在互联网+模式下，纸搬客作为一家互联网环保公司做出的创新与发展。',
                        small: '收费0.5元一条',
                        more: '查看更多>',
                        path: '/newThree'
                    }, {
                        img: require('../assets/img/news/3.png'),
                        h3: '纸搬客南华里社区环保专题采访',
                        p: '为响应国家垃圾分类的环保号召、助力垃圾分类，纸搬客通过与社区物业、居委会单位的合作，将自主研发的纸搬客智能废纸回收机入驻社区，协助物业、居委会建立社区内的垃圾分类回收体系，为用户挖掘“垃圾”价值，这一方式受到了物业、居委会以及用户的一致好评。',
                        small: '收费0.5元一条',
                        more: '查看更多>',
                        path: '/newTwo'
                    },
                    {
                        img: require('../assets/img/news/2.png'),
                        h3: '纸搬客——互联网+时代的智能废纸回收先行者',
                        p: '纸搬客诞生于2018年，时值国家重拳出击整治环保、垃圾分类政策相继出台的风口浪尖。据创始人李嘉轩先生介绍，纸搬客的创始初衷其实很简单，就是便于日常生活中产生的大量废旧纸类垃圾进行精准分类和回收再利用...',
                        small: '收费0.5元一条',
                        more: '查看更多>',
                        path: '/newOne'
                    },


                ]
            }
        },
        mounted() {
            $(function () {
                $('.banner h2').animate({
                    opacity: 1
                })
                $(window).scroll(function () {
                    var scrollT = $(window).scrollTop(); //滚动的高度
                    var ViewHeight = $(window).height(); //视口的高度
                    var contentHeight = $('.content').offset().top; //元素的高度
                    if (scrollT + ViewHeight >= contentHeight) {
                        $('.content-header h2, .content-header h3,.details-right h3,.details-right p').animate({
                            opacity: 1
                        }, 3000)
                        $('.details-left').addClass('animated fadeInLeftBig')
                        $('.details-right').addClass('animated fadeInRightBig')
                    }
                })
            })
        },
        created() {
        },
        beforeDestroy() {
            $(window).off('scroll')
        }
    }
</script>
<style scoped>
    .news {
        width: 100%;
        height: 100%;
    }

    .banner {
        position: relative;
        height: 1.93rem;
    }

    .banner img {
        width: 100%;
        height: 1.93rem;
    }

    .banner h2 {
        font-size: 0.23rem;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: rgba(255, 255, 255, 1);
        line-height: 0.29rem;
        position: absolute;
        top: 50%;
        margin-top: -0.16rem;
        left: 1.4rem;
        opacity: 0.3;
    }

    .content {
        width: 100%;
        min-height: 3.5rem;
    }

    .content-header {
        width: 100%;
        height: 0.44rem;
        border-bottom: 0.002rem solid #C7C7C7;
        padding-top: 0.08rem;
    }

    .content-header h2,
    .content-header h3 {
        text-align: center;
        font-size: 0.08rem;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: rgba(63, 63, 63, 1);
        line-height: 0.13rem;
        opacity: 0.3;
    }

    .details {
        width: 100%;
        min-height: 0.68rem;
        overflow: hidden;
        padding-bottom: 0.08rem;
    }

    .line {
        width: 2.34rem;
        border-bottom: 0.002rem solid rgba(199, 199, 199, 1);
        margin: 0 auto;
    }

    .details-left {
        width: 27%;
        min-height: 0.76rem;
        float: left;
    }

    .details-left img {
        width: 0.61rem;
        height: 0.55rem;
        float: left;
        margin-top: 0.11rem;
    }

    .details-right {
        width: 73%;
        min-height: 0.76rem;
        float: left;
        padding-left: 0.07rem;
    }

    .details-right h3 {
        font-size: 0.05rem;
        font-family: PingFang SC;
        font-weight: bold;
        color: rgba(14, 14, 14, 1);
        line-height: 0.08rem;
        margin: 0.14rem 0 0.05rem 0;
        opacity: 0.3;
    }

    .details-right p {
        font-size: 0.04rem;
        font-family: PingFang SC;
        font-weight: 500;
        color: rgba(79, 79, 79, 1);
        line-height: 0.08rem;
        opacity: 0.3;
    }

    .details-right .inline {
        width: 100%;
        overflow: hidden;
    }

    .inline .small {
        min-width: 0.27rem;
        min-height: 0.05rem;
        background: rgba(255, 214, 214, 1);
        border-radius: 0.01rem;
        float: left;
        font-size: 0.03rem;
        font-family: PingFang SC;
        font-weight: 500;
        color: rgba(255, 49, 49, 1);
        line-height: 0.05rem;
        text-align: center;
        margin-top: 0.04rem;
    }

    .inline .more {
        font-size: 0.05rem;
        font-family: PingFang SC;
        font-weight: 500;
        color: rgba(34, 34, 34, 1);
        line-height: 0.07rem;
        float: right;
        margin-top: 0.03rem;
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/views/news.vue